import React from 'react';
import {endOfMonth, endOfWeek, isSameDay, isSameMonth, startOfMonth, startOfWeek} from "date-fns";
import moment from "moment";
import Grid from "@mui/material/Grid";
import {
	Avatar,
	Card,
	CardActionArea,
	CardContent,
	CardHeader, Chip, Tooltip,
} from "@mui/material";
import clsx from "clsx";
import {addDays} from "../../../../../utils/GenericUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import itLocale from "date-fns/locale/it";
import {amber, blue, green, red} from "@mui/material/colors";
import { Skeleton } from '@mui/material';

const ScadenziarioCell = ({currentMonth, selectedDate, quarantenaState, onDateClick, isLoading}) => {
	const classes = BaseStyle();
	const monthStart = startOfMonth(currentMonth);
	const monthEnd = endOfMonth(monthStart);
	const startDate = startOfWeek(monthStart, {
		locale: itLocale
	});
	const endDate = endOfWeek(monthEnd, {
		locale: itLocale
	});
	
	const rows = [];
	let days = [];
	let day = startDate;
	day.setHours(0);
	day.setMinutes(0);
	day.setSeconds(0);
	day.setMilliseconds(0);
	let formattedDate = "";
	let key = 1234;
	
	while (day <= endDate) {
		for (let i = 0; i < 7; i++) {
			formattedDate = moment(day).format("D");
			const cloneDay = day;
			days.push(
				<Grid item xs key={day.toLocaleDateString()} style={
					!isSameMonth(day, monthStart) ? {color: "#939393"} :
						isSameDay(day, selectedDate) ? {color: "#0ff"} : {}}
				>
					{
						isLoading ?
							<Skeleton style={{height: 100}}/> :
							<Card variant={"outlined"}
							      style={isSameDay(new Date(), day) ? {borderColor: "#0097ff"} : {}}
							      className={clsx(classes.roundBorder, isSameDay(day, selectedDate) ? classes.selectedDay : "", !isSameMonth(day, monthStart) ? classes.disabledDay : "")}>
								<CardActionArea disabled={!isSameMonth(day, monthStart)}
								                onClick={() => onDateClick(new Date(cloneDay))}>
									<CardHeader style={{paddingBottom: 0}}
									            title={!isSameMonth(day, monthStart) ? formattedDate :
										            <b style={isSameDay(new Date(), day) ? {
											            color: "#004977",
										            } : {}}>{formattedDate}</b>}/>
									<CardContent className={classes.flexStart} style={{height: 96, alignContent: "flex-end"}}>
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Isolamenti in scadenza: tutti gli isolamenti con data fine al giorno selezionato con stato NUOVA e IN CORSO"}>
												<Chip avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}>IS</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: red[500], color: "#FFF"}}
												      label={quarantenaState.quaranteneMonth?.["is"]?.[new Date(day)]}/></Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Isolamenti nuovi: tutti gli isolamenti con data inizio al giorno selezionato con stato NUOVA"}>
												<Chip avatar={<Avatar style={{backgroundColor: amber[800], color: "#FFF"}}>IN</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: amber[600], color: "#FFF"}}
												      label={quarantenaState.quaranteneMonth?.["in"]?.[new Date(day)]}/>
											</Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Quarantene in scadenza: tutte le quarantene con data fine al giorno selezionato con stato NUOVA e IN CORSO"}>
												<Chip avatar={<Avatar style={{backgroundColor: green[800], color: "#FFF"}}>QS</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: green[600], color: "#FFF"}}
												      label={quarantenaState.quaranteneMonth?.["qs"]?.[new Date(day)]}/></Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Quarantene nuove: tutti le quarantene con data inizio al giorno selezionato con stato NUOVA"}>
												<Chip avatar={<Avatar style={{backgroundColor: blue[800], color: "#FFF"}}>QN</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: blue[600], color: "#FFF"}}
												      label={quarantenaState.quaranteneMonth?.["qn"]?.[new Date(day)]}/></Tooltip>}
									
									</CardContent>
								</CardActionArea>
							</Card>}
				</Grid>
			);
			day = addDays(day, 1)
		}
		rows.push(
			<Grid item xs={12} key={key}>
				<Grid container spacing={3}>
					{days}
				</Grid>
			</Grid>
		)
		key += 1;
		days = [];
	}
	
	return (
		<React.Fragment>
			<Grid container spacing={3}>
				{rows}
			</Grid>
		</React.Fragment>
	);
};

export default React.memo(ScadenziarioCell)
